import { iWAMarketingCampaign } from "@sdk/wa-marketing-campaigns/wa-marketing-campaigns-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { waMarketingCampaignsDefaultQueryConfig } from "./wa-marketing-campaigns-default-query";

export const {
  slice: WAMarketingCampaignsSlice,
  reducers: WAMarketingCampaignsSliceReducer,
  actions: {
    setEntityQueryResults: setWAMarketingCampaignsQueryResults,
    setEntity: setWAMarketingCampaign,
    setEntities: setWAMarketingCampaigns,
    patchEntity: patchWAMarketingCampaign,
    addNewEntity: addNewWAMarketingCampaign,
    setEntityFetchingStatus: setWAMarketingCampaignFetchingStatus,
    setEntitiesFetchingStatus: setWAMarketingCampaignsFetchingStatus,
    setEntityFailedStatus: setWAMarketingCampaignFailedStatus,
    setEntityQueryError: setWAMarketingCampaignsQueryError,
    resetQuery: resetWAMarketingCampaignsQuery,
    setQueryList: setWAMarketingCampaignQueryList,
  },
} = CreateEntitySlice<iWAMarketingCampaign>({
  sliceName: "waMarketingCampaigns",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...waMarketingCampaignsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
